import styled, { css } from 'styled-components';
import { media } from '../../../../constants/media/media';
import theme from '../../../../constants/theme';
import { Column, Columns } from '../../../base/grid';

export const Wrapper = styled.div``;

export const ShipmentAdditionalInfo = styled(Columns)`
	${media.tablet`
		border-top: 1px solid ${theme.colors.grayLighter};
	`}
	margin: 0;
`;

export const EventItem = styled.div`
	display: flex;
	flex-wrap: wrap;
`;

export const ShipmentsAdditionalInfoHeading = styled.div`
	color: ${theme.colors.black};
	font-weight: 700;
	font-size: 2.5rem;
	margin-bottom: 4rem;
`;

export const DropOffWrapperAdditional = styled(Columns)`
	background-color: ${theme.colors.grayLighter};
	padding: 2rem 2rem 0rem;
	font-size: 1rem;
	margin: 0;
`;

export const DropOffWrapper = styled(Columns)`
	margin: 0;
	border-top: 1px solid ${theme.colors.grayLighter};
	position: relative;
	width: 100%;

	button {
		margin-top: 3rem;
	}

	> div {
		padding: 4rem;
		text-align: center;
		margin-bottom: 0;
		svg {
			height: 4rem;
			width: auto;
		}
	}
	> div:first-child {
		${media.tablet`
			border-right: 1px solid ${theme.colors.grayLighter};
		`}
		${media.mobileOnly`
			border-bottom: 1px solid ${theme.colors.grayLighter};
		`}
	}
	span {
		width: 100%;
		display: grid;
		place-items: center;
		pointer-events: none;

		${media.tablet`
			top: 0;
			left: 0;
			position: absolute;
			height: 100%;
		`}

		p {
			background-color: ${theme.colors.white};
			margin: 0;
			padding: 0;
		}

		${media.mobileOnly`
			p {
				background-color: ${theme.colors.white};
				margin -1.5rem 0;
				padding: 0 1rem;
			}
		`}
	}
`;

export const DropOffWrapperSimplified = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 4rem;
	border-top: 1px solid ${theme.colors.grayLighter};

	div {
		width: 100%;
		text-align: center;
	}
	a {
		margin-left: auto !important;
		margin-right: auto !important;
	}
	svg {
		margin-top: 2rem;
	}
`;

export const TrackingInfo = styled(Column)`
	margin-bottom: 0px;
	h4 {
		margin-bottom: 3rem;
		${media.mobileOnly`
			display: none;
		`}
	}
	padding: 4rem 5rem;
	border-right: 1px solid ${theme.colors.grayLighter};
`;

export const FeesWrapper = styled.div`
	padding: 4rem 5rem;
	${media.tablet`
		border-bottom: 1px solid ${theme.colors.grayLighter};
	`}
`;

export const DocumentsWrapper = styled.div`
	padding: 4rem 5rem;
	button {
		width: 100%;
	}
`;

export const Documents = styled(Column)`
	padding: 0;
	h5 {
		margin-bottom: 3rem;
		${media.mobileOnly`
			display: none;
		`}
	}
	${media.mobileOnly`
		border-top: 1px solid ${theme.colors.grayLighter};
		div>div>div:last-child {
			text-align: right;
		}
	`}
`;

export const FilesList = styled(Column)`
	padding: 0;
	display: flex;
	justify-content: space-between;
	gap: 1.5rem;

	> div:first-child {
		min-width: 0;
		overflow-wrap: anywhere;
	}

	> div:last-child {
		flex-shrink: 0;
		white-space: nowrap;
	}
`;

export const FeesList = styled(Column)`
	padding: 0;
	display: flex;
	justify-content: space-between;
`;

export const CustomsItemsList = styled.ul`
	display: grid;
	gap: 0.8rem;
`;

export const CustomsWeightItem = styled.li`
	margin-top: 1.6rem;
	padding-top: 1.6rem;
	border-top: 1px solid ${theme.colors.grayLighter};
	font-weight: ${theme.fonts.weight.bold};
`;

export const MapContainer = styled.div`
	flex: 1;
	min-height: 40rem;

	${media.mobileOnly`
        display: none;
    `}
`;

export const Dot = styled.div`
	width: 1.7rem;
	height: 1.7rem;
	margin: 1.5rem 3rem;
	border-radius: 100%;
	background-color: ${theme.colors.secondary};
	border: 0.4rem solid white;
	justify-self: center;
	align-self: center;

	${({ active }) =>
		active &&
		css`
			background-color: ${theme.colors.primary};
			position: relative;
			border: 0;

			&:before {
				background: none;
				border: 3px solid #fff;
				content: '';
				display: block;
				position: absolute;
				border-radius: 100%;
				top: 1px;
				left: 1px;
				right: 1px;
				bottom: 1px;
				pointer-events: none;
			}
		`};

	${({ future }) =>
		future &&
		css`
			background-color: ${theme.colors.gray};
			position: relative;
			border: 0;

			&:before {
				background: none;
				border: 3px solid #fff;
				content: '';
				display: block;
				position: absolute;
				border-radius: 100%;
				top: 1px;
				left: 1px;
				right: 1px;
				bottom: 1px;
				pointer-events: none;
			}
		`};
`;

export const Line = styled.div`
	width: 2px;
	height: 7rem;
	margin: -1rem 0;
	justify-self: center;
	background-color: ${theme.colors.secondary};
`;

export const Timestamp = styled.div`
	div:first-child {
		font-size: 1.8rem;
		line-height: 1.7rem;
		color: ${theme.colors.black};
		font-weight: 700;
	}
	${media.mobileOnly`
		display: none;
	`}
`;

export const Description = styled.div`
	div:first-child {
		font-size: 1.8rem;
		line-height: 1.7rem;
		color: ${theme.colors.black};
		font-weight: 700;
	}
	font-size: 1.6rem;
`;

export const StyledErrorMessage = styled.div`
	margin-top: 1rem;
	color: ${theme.colors.primary};
	text-transform: uppercase;
`;

export const Content = styled.div`
	padding: 4rem 5rem;
`;
